<mat-toolbar color="primary">
    <!-- Menu toggle -->
    <div class="side-nav-toggle">
        <button mat-icon-button class="toggle-button">
            <mat-icon>menu</mat-icon>
        </button>
    </div>

    <!-- Logo -->
    <div class="logo">
        <div class="svg-logo">
            <img alt="ADB Safegate logo" src="assets/svg/logo.svg" />
        </div>
    </div>

    <div class="spacer"></div>

    <!-- Time -->
    <app-time-display></app-time-display>
</mat-toolbar>
